import type { ShellNavItem } from './types'

// Lowercase and without accents, so "reuni" finds "Reuniões" and "CLI" finds "Clientes".
export function normalizeNavText(text: string): string {
  return text
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim()
}

// Menu filter (field next to the menu button): keeps the items whose name contains the text. A group
// whose own name matches keeps all its sub-items; otherwise it stays only with the sub-items that match.
export function filterNav(items: ShellNavItem[], query: string): ShellNavItem[] {
  const needle = normalizeNavText(query)
  if (!needle) return items
  const matches = (item: ShellNavItem) => normalizeNavText(item.label).includes(needle)
  return items.flatMap((item) => {
    if (!item.children?.length) return matches(item) ? [item] : []
    if (matches(item)) return [item]
    const children = item.children.filter(matches)
    return children.length ? [{ ...item, children }] : []
  })
}

// Pages in menu order (sub-items in place of their group): Enter in the filter opens the first one.
export function navLinks(items: ShellNavItem[]): ShellNavItem[] {
  return items.flatMap((item) => (item.children?.length ? item.children.filter((child) => child.to) : item.to ? [item] : []))
}
